import z from 'zod'
import { parseWithZod } from '../utils'
import { http } from './http'
import { DealCategorySchema } from '../schemas'

const DealCategoriesResponseSchema = z.object({
  deal_categories: z.array(DealCategorySchema),
})

export const dealCategories = {
  getAll: async (regionHost: string) => {
    const result = await http.get(`${location.protocol}//${regionHost}/api/deal_categories`)
    return parseWithZod(DealCategoriesResponseSchema, result).deal_categories
  },
}
